import { render } from "./MenuSeparator.vue?vue&type=template&id=bbf38628&ts=true"
import script from "./MenuSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSeparator.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuSeparator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbf38628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbf38628', __exports__)) {
    api.reload('bbf38628', __exports__)
  }
  
  module.hot.accept("./MenuSeparator.vue?vue&type=template&id=bbf38628&ts=true", () => {
    api.rerender('bbf38628', render)
  })

}


export default __exports__